module.exports = __webpack_public_path__ + "img/03招标.a41c3285.jpg";